const rankingItems = [
  {
    rank: 1,
    title: '当红顶流深夜密会被拍，疑似新恋情浮出水面',
    heat: '128.5万',
    trend: 'up',
    change: '+32%',
  },
  {
    rank: 2,
    title: '热门综艺录制现场爆发争执，导演紧急叫停',
    heat: '106.2万',
    trend: 'up',
    change: '+18%',
  },
  {
    rank: 3,
    title: '年度盛典红毯生图流出，谁的状态最能打',
    heat: '94.8万',
    trend: 'down',
    change: '-5%',
  },
  {
    rank: 4,
    title: '顶流歌手巡回演唱会突发意外，现场歌迷炸锅',
    heat: '87.3万',
    trend: 'up',
    change: '+25%',
  },
  {
    rank: 5,
    title: '某女星被拍到与神秘男子同游，新恋情曝光',
    heat: '76.1万',
    trend: 'new',
    change: 'NEW',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              实时榜单
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              热度排行
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              基于全网讨论量实时计算的今日吃瓜热度TOP5
            </p>
          </div>

          <div className="max-w-3xl mx-auto space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer"
              >
                <div
                  className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl font-heading font-bold text-lg ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                        ? 'bg-primary-400 text-white'
                        : item.rank === 3
                          ? 'bg-accent-500 text-white'
                          : 'bg-secondary-200 text-secondary-700'
                  }`}
                >
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </p>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-fire-line text-xs"></i>
                      {item.heat} 热度
                    </span>
                    <span
                      className={`text-xs font-semibold flex items-center gap-0.5 ${
                        item.trend === 'up'
                          ? 'text-primary-600'
                          : item.trend === 'down'
                            ? 'text-accent-600'
                            : 'text-accent-500'
                      }`}
                    >
                      {item.trend === 'up' && <i className="ri-arrow-up-line text-xs"></i>}
                      {item.trend === 'down' && <i className="ri-arrow-down-line text-xs"></i>}
                      {item.change}
                    </span>
                  </div>
                </div>

                <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}